import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Colors, getThemeColors } from "../constants/Colors";

const ThemeProvider = ({ children }) => {
  const theme = useSelector((state) => state.theme.mode);

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);

    const themeColors = getThemeColors(theme);

    // Set CSS variables for global use

    // 1. Inject Raw Palette Colors (for specific use cases)
    document.documentElement.style.setProperty(
      "--color-raw-white",
      Colors.white,
    );
    document.documentElement.style.setProperty(
      "--color-raw-alabaster-grey",
      Colors.alabasterGrey,
    );
    document.documentElement.style.setProperty(
      "--color-raw-granite",
      Colors.granite,
    );
    document.documentElement.style.setProperty(
      "--color-raw-porcelain",
      Colors.porcelain,
    );
    document.documentElement.style.setProperty(
      "--color-raw-white-2",
      Colors.white2,
    );
    document.documentElement.style.setProperty(
      "--color-raw-white-3",
      Colors.white3,
    );
    document.documentElement.style.setProperty(
      "--color-raw-contest-gold",
      Colors.contestGold,
    );
    document.documentElement.style.setProperty(
      "--color-raw-contest-light-green",
      Colors.contestLightGreen,
    );
    document.documentElement.style.setProperty(
      "--color-raw-sttGreen",
      Colors.sttGreen,
    );
    document.documentElement.style.setProperty(
      "--color-sttGreen",
      Colors.sttGreen,
    );

    // 2. Inject Functional Colors
    document.documentElement.style.setProperty(
      "--color-success",
      Colors.success,
    );
    document.documentElement.style.setProperty("--color-error", Colors.error);
    document.documentElement.style.setProperty(
      "--color-warning",
      Colors.warning,
    );
    document.documentElement.style.setProperty("--color-info", Colors.info);

    // 3. Inject Semantic Theme Colors (Dynamic based on theme)
    // These are the ones you should primarily use in your CSS
    document.documentElement.style.setProperty(
      "--color-background",
      themeColors.background,
    );
    document.documentElement.style.setProperty(
      "--color-surface",
      themeColors.surface,
    );
    document.documentElement.style.setProperty(
      "--color-text",
      themeColors.text,
    );
    document.documentElement.style.setProperty(
      "--color-text-secondary",
      themeColors.textSecondary,
    );
    document.documentElement.style.setProperty(
      "--color-text-tertiary",
      themeColors.textTertiary,
    );
    document.documentElement.style.setProperty(
      "--color-text-inverse",
      themeColors.textInverse,
    );
    document.documentElement.style.setProperty(
      "--color-border",
      themeColors.border,
    );
    document.documentElement.style.setProperty(
      "--color-shadow",
      themeColors.shadow || "rgba(0, 0, 0, 0.12)",
    );

    // 4. Inject Primary/Secondary/Tertiary (Dynamic based on theme preference)
    if (themeColors.primary) {
      document.documentElement.style.setProperty(
        "--color-primary",
        themeColors.primary,
      );
    } else {
      document.documentElement.style.setProperty(
        "--color-primary",
        Colors.primary,
      );
    }

    if (themeColors.secondary) {
      document.documentElement.style.setProperty(
        "--color-secondary",
        themeColors.secondary,
      );
    } else {
      document.documentElement.style.setProperty(
        "--color-secondary",
        Colors.secondary,
      );
    }

    if (themeColors.tertiary) {
      document.documentElement.style.setProperty(
        "--color-tertiary",
        themeColors.tertiary,
      );
    } else {
      document.documentElement.style.setProperty(
        "--color-tertiary",
        Colors.tertiary,
      );
    }

    // 5. Inject Contest Colors (Dynamic based on theme)
    if (themeColors.contestGold) {
      document.documentElement.style.setProperty(
        "--color-contest-gold",
        themeColors.contestGold,
      );
    } else {
      document.documentElement.style.setProperty(
        "--color-contest-gold",
        Colors.contestGold,
      );
    }

    if (themeColors.contestLightGreen) {
      document.documentElement.style.setProperty(
        "--color-contest-light-green",
        themeColors.contestLightGreen,
      );
    } else {
      document.documentElement.style.setProperty(
        "--color-contest-light-green",
        Colors.contestLightGreen,
      );
    }
  }, [theme]);

  return <>{children}</>;
};

export default ThemeProvider;
